import { Button } from '@chakra-ui/react'
import { FC } from 'react'

import useTools from '@hook/shared/use-tools'

import type { ILayoutToolsButtonProps } from '@base/@types/components/Layout/Tools'

const LayoutToolsButton: FC<ILayoutToolsButtonProps> = ({
  label,
  isLoading,
  loadingText,
  onClick,
  isDisabledDefault
}) => {
  const { isDisabled } = useTools()

  return (
    <Button
      size="xs"
      fontSize="12px"
      letterSpacing=".2px"
      p="4px 6px"
      bg="gray.200"
      fontWeight="400"
      isDisabled={
        isDisabledDefault !== undefined ? isDisabledDefault : isDisabled
      }
      isLoading={isLoading}
      loadingText={loadingText}
      spinnerPlacement="start"
      onClick={onClick}
      _hover={{ bgColor: 'gray.100' }}
      _active={{ bgColor: 'gray.100' }}
    >
      {label}
    </Button>
  )
}

export default LayoutToolsButton
